import { ListButton } from "@refinedev/antd";
import {
  Col,
  Row,
  Result,
  Spin,
  Typography,
  message,
  Form,
  Card,
  Badge,
  CollapseProps,
  Collapse,
  Divider,
  Input,
} from "antd";
import { useGo, useNavigation, useTranslate } from "@refinedev/core";
import {
  FilterOutlined,
  FlagOutlined,
  EditOutlined,
  HistoryOutlined,
  LeftOutlined,
  MailOutlined,
  MessageOutlined,
  PhoneOutlined,
  PlusOutlined,
  ProfileOutlined,
  ShopOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { Flex, Button, Tag, theme } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  axiosInstance,
  resolveStoreId,
  displayEmail,
  formatPrice,
  isSyntheticEmail,
  transformToFunnelData,
} from "@/utilities";
import { API_BASE_URL } from "@/services/XCONS_ENV";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { HistorySection } from "@/components/history/HistorySection";
import {
  PresupuestoIcon,
  SpecialFunnel,
  StatusSummary,
  BoxCloseIcon,
} from "@/components";
import React from "react";
import { HandshakeIcon } from "@/components/icon/HandshakeIcon";
import dayjs from "dayjs";
import { LateralModal } from "@/components/modals/LateralModal";
import { ContactGroupCard } from "@/components/groups-card";
import { RelationsCard } from "@/components/relations-card";
import { Agenda } from "./Address/agenda";
import { fromV1 } from "./Address/agenda.adapter";
import { ContactData } from "./ContactData";
import { MergeContactDrawer, MergeSourcePreset } from "./Merge";
import { ChannelPickerDropdown, channelIcon, useWritableChannels } from "@/components/channel-picker";
import { getOperatorTags } from "./utils/operatorTags";
import { API_URL_STORES } from "@/services/XCONS_ENV";
import { AditionalData } from "./AditionalData";
import { StatusOrdersIcons } from "@/components/tags/orders-status-icons";
import { useGetIdentity } from "@refinedev/core";
import { useSelectedStores } from "@/config/context/SelectedItemsContext";

const { Title, Text, Link } = Typography;
type EditingSection = "contact" | "aditional" | null;

export const ContactDetails = () => {
  const [orderLoading, setOrderLoading] = useState<boolean>(false);
  const [quotesLoading, setQuotesLoading] = useState<boolean>(false);
  const [contactLoading, setContactLoading] = useState<boolean>(false);
  const [userAddressLoading, setUserAddressLoading] = useState<boolean>(false);
  const [quotesData, setQuotesData] = useState<any>([]);
  const [contactRecord, setContactRecord] = useState<any>([]);
  const [ordersData, setOrdersData] = useState<any>([]);
  const [userData, setUserData] = useState<any>([]);
  const [contactsGroup, setContactsGroup] = useState<any>([]);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [storesSelectProps, setStoresSelectProps] = useState<any>();
  const [editingSection, setEditingSection] = useState<EditingSection>(null);
  // Drawer de edición de Datos del contacto / Additional data. Se abre desde los
  // lápices (email → contact, "Additional data" → aditional), sin el paso previo
  // de elegir qué editar.
  const [dataDrawerOpen, setDataDrawerOpen] = useState<boolean>(false);
  // Modal de Agenda controlado desde afuera (el link "Agenda" y su lápiz).
  const [agendaOpen, setAgendaOpen] = useState<boolean>(false);
  const [historySearch, setHistorySearch] = useState("");
  const [historyQ, setHistoryQ] = useState("");
  useEffect(() => {
    const t = setTimeout(() => setHistoryQ(historySearch.trim()), 350);
    return () => clearTimeout(t);
  }, [historySearch]);
  // "Agregar" de Grupos/Relaciones se dispara desde el header del collapse.
  const [addingGroup, setAddingGroup] = useState<boolean>(false);
  const [addingRelation, setAddingRelation] = useState<boolean>(false);
  const [loadingContactsG, setLoadingContactsG] = useState(false);
  const [userAddress, setUserAddress] = useState<any>([]);
  const [modalTitle, setModalTitle] = useState("Agenda");
  const { data: identity, isLoading } = useGetIdentity();
  const [mergeOpen, setMergeOpen] = useState(false);
  /**
   * Unificación disparada desde el conflicto de identidad al editar la ficha (OpenSpec 021): el
   * operador tipeó el e-mail o el WhatsApp de otro contacto y aceptó unificar. Guarda el par ya
   * resuelto por el backend — `targetContactId` puede no ser esta ficha, sino la de esta identidad
   * en el store que las dos comparten, porque unificar es dentro de un mismo store.
   */
  const [mergeFromConflict, setMergeFromConflict] = useState<{
    targetContactId: number;
    source: MergeSourcePreset;
    triggerField?: "email" | "whatsapp";
  } | null>(null);
  const { addStore, clearStores } = useSelectedStores();

  const t = useTranslate();
  const { token } = theme.useToken();
  const { goBack } = useNavigation();
  const [form] = Form.useForm();
  const location = useLocation();

  const { id } = useParams();
  const navigate = useNavigate();
  const {
    channels: convChannels,
    unavailable: convChannelsUnavailable,
    loading: convChannelsLoading,
    failed: convChannelsFailed,
    load: loadConvChannels,
  } = useWritableChannels(contactRecord?.storeCode, userData?.whatsapp, {
    iniciaConPlantilla: true,
  });
  /**
   * Fuerza el refetch de todo lo que cuelga del contacto. Lo necesita la unificación (OpenSpec 021):
   * `getContactDetails` sola **no alcanza**, porque los fetches de usuario, presupuestos, pedidos,
   * direcciones y relaciones cuelgan de un effect keyed en `[userId]`, y al unificar el `userId` del
   * contacto que se queda **no cambia** — así que el effect no volvía a correr y la ficha seguía
   * mostrando los datos de antes de absorber al otro.
   */
  const [refreshKey, setRefreshKey] = useState(0);
  const contactId = location.state?.record?.contactId ?? id;
  const [userId, setUserId] = useState<string>();
  /**
   * Qué contestó `GET /contacts/:contactId` (xcons-docs#549). Antes la ficha se cargaba con el
   * listado filtrado por id, que responde `200` con la página vacía tanto si la ficha no existe
   * como si está fuera del alcance del operador —"Por participación" sin participar de ésta—, y
   * la página renderizaba todo `undefined` con el historial cargado abajo. Ahora el endpoint
   * contesta `403` o `404`, y acá se muestra eso en lugar de los campos vacíos.
   */
  const [contactAccess, setContactAccess] = useState<"ok" | "forbidden" | "notFound">("ok");

  const handleBack = () => {
    goBack();
  };

  // Un contacto es "persona-en-un-store": la ficha muestra sus presupuestos y
  // pedidos SOLO en el store del contacto (contactRecord.storeCode), no en los
  // otros stores donde ese user pueda tener actividad. Independiente del
  // StoreFilter global.
  const contactStoreCode = () => String(contactRecord?.storeCode ?? "").trim();

  const withStoreFilter = (params: Record<string, any> = {}) => {
    const code = contactStoreCode();
    if (!code) return params;
    return { ...params, "filter.storeCode": code };
  };

  const quotesFilters = (params: Record<string, any> = {}) => {
    const code = contactStoreCode();
    if (!code) return params;
    return { ...params, "filter.store.code": code };
  };

  // Acceso directo a /quotes o /orders: fija el StoreFilter global al store del
  // contacto para que la lista destino quede scopeada al mismo store que la
  // ficha (la lista usa selectedStores vía useStoreFilters).
  const scopeGlobalToContactStore = () => {
    const code = contactStoreCode();
    const store = (storesSelectProps ?? []).find(
      (s: any) => String(s?.code ?? "").trim() === code,
    );
    clearStores();
    if (store) {
      addStore({
        code: store.code,
        name: store.name,
        seller_id: store.store_id,
      });
    }
  };

  const beginEdit = (section: Exclude<EditingSection, null>) => {
    // Archivado (Fase 2): en un contacto archivado solo se permite editar
    // Contact data (para poder reactivarlo). El resto de acciones se bloquea.
    if (section !== "contact" && contactRecord?.archived) return;
    setEditingSection(section);
  };

  const endEdit = () => {
    setEditingSection(null);
  };

  // Abrir el drawer directamente en modo edición de una sección (desde los lápices).
  const openContactEdit = () => {
    beginEdit("contact");
    setDataDrawerOpen(true);
  };
  const openAditionalEdit = () => {
    if (contactRecord?.archived) return; // archivado: solo Edit contact data
    beginEdit("aditional");
    setDataDrawerOpen(true);
  };
  const closeDataDrawer = () => {
    setDataDrawerOpen(false);
    endEdit();
  };

  /**
   * Fin de una unificación. Dos caminos, porque el contacto que sobrevive puede no ser esta ficha:
   * si el operador **cambió el store** en el selector del drawer, el destino es otra ficha y hay que
   * ir ahí. (Entrando por el conflicto de identidad el par ya viene del store de esta ficha, así que
   * ese caso refresca; antes el par podía salir de otro store compartido y esto era lo normal.)
   */
  const handleMergeDone = (survivingContactId: number) => {
    if (survivingContactId && survivingContactId !== Number(contactId)) {
      navigate(`/contacts/${survivingContactId}`);
      return;
    }
    getContactDetails();
    // Remonta el historial y re-dispara los fetches que cuelgan de [userId], que no cambia al unificar.
    setRefreshKey((key) => key + 1);
  };

  /**
   * Refresco completo de la ficha, para después de guardar.
   *
   * `getContactDetails()` **sola no alcanza**, por el mismo motivo que ya estaba documentado para
   * la unificación: los fetches de usuario, presupuestos, pedidos, direcciones y relaciones cuelgan
   * de un effect keyed en `[userId, refreshKey]`, y `getContactDetails` los dispara haciendo
   * `setUserId(contact.userId)` — que al guardar setea **el mismo valor que ya tenía**. React
   * descarta un set idéntico, el effect no vuelve a correr y `userData` queda viejo hasta que
   * alguien recarga la página.
   *
   * Se veía poco porque el encabezado saca el nombre de `contactRecord`, que sí se refresca. La
   * Empresa vive sólo en `userData`, así que ahí no hay nada que tape el dato viejo.
   */
  const refreshAfterSave = () => {
    getContactDetails();
    setRefreshKey((key) => key + 1);
  };

  const getContactDetails = async () => {
    setContactLoading(true);
    try {
      // La ficha por su endpoint, no el listado filtrado: es la misma fila, pero con `403` y
      // `404` en vez de una página vacía (xcons-docs#549).
      const res = await axiosInstance.get(`${API_BASE_URL}/contacts/${contactId}`);
      const contact = res?.data || null;
      setContactAccess("ok");
      setContactRecord(contact);
      // Setting userId triggers the useEffect on [userId, refreshKey] which calls
      // getUser/getQuotes/getOrders/etc with the updated state. Calling
      // getUser() here directly would race against setState and request
      // /users/undefined.
      //
      // ⚠️ Sólo dispara el effect si el userId CAMBIA. Cuando no cambia —guardar la ficha, o
      // unificar quedándose con este contacto— hay que bumpear `refreshKey` además: para eso
      // están `refreshAfterSave` y `handleMergeDone`.
      setUserId(contact?.userId);
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 403) setContactAccess("forbidden");
      else if (status === 404) setContactAccess("notFound");
      console.error(error);
    } finally {
      setContactLoading(false);
    }
  };

  const getUser = async () => {
    setOrderLoading(true);
    try {
      // OpenSpec 024 — el `contactId` scopea la respuesta a ESTA ficha: `firstname` / `lastname`
      // vienen con el nombre del store, y el de la identidad de Magento queda en
      // `identityFirstname` / `identityLastname`.
      //
      // Sin esto el drawer "Contact data" precargaba el nombre de la identidad mientras el
      // encabezado mostraba el de la ficha, y guardar sin tocar el campo le pisaba a la ficha su
      // propio nombre con el global.
      const res = await axiosInstance.get(
        `${API_BASE_URL}/users/${userId}`,
        { params: contactId ? { contactId } : undefined },
      );
      setUserData(res?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setOrderLoading(false);
    }
  };

  const getQuotes = async () => {
    setQuotesLoading(true);
    try {
      const res = await axiosInstance.get(`${API_BASE_URL}/quotes`, {
        // Owner-only (Contactos.md): la ficha muestra solo los presupuestos de
        // los que el contacto es owner, no los que figura como participante.
        //
        // Se filtra por `ownerContactId` y NO por `filter.userId`: una quote
        // creada desde el admin nace con `customer_id = <operador>`, así que
        // filtrar por userId la mostraba en la ficha del operador en lugar de
        // la del cliente. El backend resuelve owner = participación
        // customer-level de menor `position` (ver utils/resolveOwner.ts), con
        // fallback a `customer_id` para las quotes legacy de Magento que no
        // tienen ninguna participación de owner.
        params: quotesFilters({ "filter.ownerContactId": contactId }),
      });

      const allQuoteSellers = res.data?.data?.flatMap(
        (item: any) => item.quoteSellers || [],
      );
      setQuotesData(allQuoteSellers);
    } catch (error) {
      console.error(error);
    } finally {
      setQuotesLoading(false);
    }
  };

  const getOrders = async () => {
    setOrderLoading(true);
    try {
      const res = await axiosInstance.get(`${API_BASE_URL}/orders`, {
        params: withStoreFilter({ "filter.customerId": userId }),
      });
      setOrdersData(res?.data?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setOrderLoading(false);
    }
  };

  const getRelations = async () => {
    setLoadingGroups(true);
    try {
      if (!contactId) return;
      const res = await axiosInstance.get(
        `${API_BASE_URL}/contact-groups/relations?filter.contactId=${contactId}`,
      );
      setContactsGroup(res?.data?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingGroups(false);
    }
  };

  const getUserAddress = async () => {
    setUserAddressLoading(true);
    try {
      const params: Record<string, string | number> = {
        user_id: Number(userId),
      };
      const storeCode = String(contactRecord?.storeCode ?? "").trim();
      if (storeCode) params.store = storeCode;
      const res = await axiosInstance.get(`${API_BASE_URL}/addresses`, {
        params,
      });
      const rows = Array.isArray(res?.data) ? res.data : res?.data?.data ?? [];
      setUserAddress(rows.map(fromV1));
    } catch (error) {
      console.error(error);
    } finally {
      setUserAddressLoading(false);
    }
  };

  const handleDeleteGroup = async (contactId: number, groupId: number) => {
    setLoadingContactsG(true);
    try {
      await axiosInstance.delete(
        `${API_BASE_URL}/contact-groups/relations/${groupId}`,
      );
      message.success("Grupo eliminado correctamente");
      getRelations();
      getContactDetails();
    } catch (error) {
      message.error("Error al eliminar el grupo");
    } finally {
      setLoadingContactsG(false);
    }
  };

  useEffect(() => {
    getContactDetails();
  }, []);

  useEffect(() => {
    if (!userId) return;

    getUser();
    getQuotes();
    getOrders();
    getUserAddress();
    getRelations();
  }, [userId, refreshKey]);

  const getStores = async () => {
    try {
      // Con `includeSellerLinked`: el operador de seller no administra el store del contacto,
      // opera en él, y sin el flag no volvía y el acceso a /quotes y /orders quedaba sin scopear.
      const response = await axiosInstance.get(API_URL_STORES, {
        params: { includeSellerLinked: true, limit: 100 },
      });
      const stores = response.data.data;
      setStoresSelectProps(stores);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getStores();
  }, []);

  const go = useGo();

  const HeaderCollapse = React.memo(
    ({
      icon,
      title,
      count = 0,
      total = 0,
      green = true,
      x = true,
      onClick,
      action,
    }: {
      icon: React.ReactNode;
      title: string;
      count?: number;
      total?: number;
      green?: boolean;
      x?: boolean;
      onClick?: () => void;
      action?: React.ReactNode;
    }) => (
      <Flex align="center" justify="space-between">
        <Flex
          align="center"
          gap={6}
          style={{ color: green ? token.colorPrimary : "" }}
        >
          {icon}{" "}
          {onClick && count !== 0 ? (
            <Link
              onClick={onClick}
              style={{ color: green ? token.colorPrimary : "" }}
              strong
              target="_blank"
            >
              {title}
            </Link>
          ) : (
            <Text strong style={{ color: green ? token.colorPrimary : "" }}>
              {title}
            </Text>
          )}
        </Flex>
        <Flex align="center" gap={8}>
          <div>
            <Text type="secondary">{count !== 0 ? count : null}</Text>
            <Text type="secondary">{x && count !== 0 ? " x " : null}</Text>
            <Text strong>{`${
              total.toLocaleString() !== "0" ? formatPrice(total) : ""
            }`}</Text>
          </div>
          {action}
        </Flex>
      </Flex>
    ),
  );

  const { funnelItems, countTotal, numberTotal } =
    transformToFunnelData(quotesData);

  const handleNewQuote = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      const storeId = await resolveStoreId(contactStoreCode());
      if (!storeId) {
        message.error("No se pudo resolver el store del contacto");
        return;
      }
      const { data } = await axiosInstance.post(`${API_BASE_URL}/quotes`, {
        storeId,
        customerId: userId,
      });
      const newQuoteId = data?.quoteId;
      if (newQuoteId) window.open(`/quotes/${newQuoteId}`, "_blank");
    } catch (err: any) {
      message.error(
        `No se pudo crear el presupuesto: ${
          err?.response?.data?.message ?? err?.message
        }`,
      );
    }
  };

  const collapseQuotes: CollapseProps["items"] = [
    {
      key: "quotes",
      label: (
        <HeaderCollapse
          icon={<PresupuestoIcon style={{ fontSize: 16 }} />}
          count={countTotal}
          total={numberTotal}
          title={t("menu.label.quotes")}
          action={
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="small"
              onClick={handleNewQuote}
              style={{ borderRadius: 6 }}
            />
          }
          onClick={() => {
            scopeGlobalToContactStore();
            go({
              to: "/quotes",
              type: "push",
              query: {
                filters: [
                  {
                    // Owner-only: presupuestos donde el contacto es owner
                    // (quote.customer_id), no como participante.
                    field: "userId",
                    operator: "eq",
                    value: contactRecord?.userId,
                  },
                ],
              },
            });
          }}
        />
      ),
      children: <SpecialFunnel list={funnelItems} loading={quotesLoading} />,
    },
  ];

  const collapseConversations: CollapseProps["items"] = [
    {
      key: "conversations",
      label: (
        <HeaderCollapse
          icon={<MessageOutlined style={{ fontSize: 16 }} />}
          title={t("menu.label.conversations")}
        />
      ),
      children: (
        <Flex vertical gap={10}>
          <Flex justify="space-between" style={{ width: "100%" }}>
            <Text>
              {t("quotes.status.Open")}{" "}
              <Badge style={{ marginLeft: 5 }} status="default" />
            </Text>
            <Text type="secondary">0</Text>
          </Flex>

          <Flex justify="space-between" style={{ width: "100%" }}>
            <Text>
              {t("conversations.badge.status.closed")}{" "}
              <Badge style={{ marginLeft: 5 }} status="default" />
            </Text>
            <Text type="secondary">0</Text>
          </Flex>

          <Flex justify="space-between" style={{ width: "100%" }}>
            <Text>
              {t("conversations.badge.status.unassigned")}{" "}
              <Badge style={{ marginLeft: 5 }} status="default" />
            </Text>
            <Text type="secondary">0</Text>
          </Flex>
        </Flex>
      ),
    },
  ];

  const collapseOrders: CollapseProps["items"] = [
    {
      key: "orders",
      label: (
        <HeaderCollapse
          icon={
            <BoxCloseIcon style={{ fontSize: 16, width: 22, height: 22 }} />
          }
          title={t("menu.label.orders")}
          count={ordersData?.length}
          total={ordersData?.reduce(
            (sum: number, order: any) => sum + (order.grandTotal || 0),
            0,
          )}
          onClick={() => {
            scopeGlobalToContactStore();
            go({
              to: "/orders",
              type: "push",
              query: {
                filters: [
                  {
                    field: "customerId",
                    operator: "eq",
                    value: contactRecord?.userId,
                  },
                ],
              },
            });
          }}
        />
      ),
      children: (
        <Flex vertical justify="space-between" style={{ height: 348 }}>
          <StatusOrdersIcons orders={ordersData} />
        </Flex>
      ),
    },
  ];

  const collapseGroups: CollapseProps["items"] = [
    {
      key: "groups",
      label: (
        <HeaderCollapse
          green={false}
          icon={<TeamOutlined style={{ fontSize: 16 }} />}
          title={t("contacts.table.groups")}
          x={false}
        />
      ),
      extra: (
        <Button
          size="small"
          shape="round"
          iconPosition="end"
          icon={<UsergroupAddOutlined />}
          disabled={!!contactRecord?.archived}
          onClick={(e) => {
            e.stopPropagation();
            setAddingGroup(true);
          }}
        >
          {t("buttom.add")}
        </Button>
      ),
      children: (
        <Spin spinning={loadingContactsG}>
          <Flex vertical gap={18}>
            <ContactGroupCard
              contactId={contactId || ""}
              apiData={contactsGroup}
              onDeleteGroup={handleDeleteGroup}
              updateRelations={getRelations}
              loadingGroups={loadingGroups}
              contactRecord={contactRecord}
              updateContactRecord={getContactDetails}
              addOpen={addingGroup}
              onCloseAdd={() => setAddingGroup(false)}
            />
          </Flex>
        </Spin>
      ),
    },
  ];

  const collapseRelations: CollapseProps["items"] = [
    {
      key: "relations",
      label: (
        <HeaderCollapse
          green={false}
          icon={<HandshakeIcon style={{ fontSize: 16 }} />}
          title={t("contacts.table.relations")}
          count={contactRecord?.participations?.length || ""}
          x={false}
        />
      ),
      extra: (
        <Button
          size="small"
          shape="round"
          iconPosition="end"
          icon={<HandshakeIcon />}
          style={{ marginLeft: 12 }}
          disabled={!!contactRecord?.archived}
          onClick={(e) => {
            e.stopPropagation();
            setAddingRelation(true);
          }}
        >
          {t("buttom.add")}
        </Button>
      ),
      children: (
        <Flex vertical gap={18}>
          <RelationsCard
            contactId={contactId || ""}
            apiData={contactRecord}
            identity={identity}
            addOpen={addingRelation}
            onCloseAdd={() => setAddingRelation(false)}
            onRelationsChanged={getContactDetails}
          />
        </Flex>
      ),
    },
  ];

  const additionalEntries = Object.entries(contactRecord?.additionalData ?? {});

  // Unificar contactos exige Contactos nivel `admin` (OpenSpec 021 · D3): es una acción
  // irreversible, y a diferencia del resto del módulo NO se resuelve por participación.
  // `identity.permissions` viene de `GET /auth/profile`, con la forma
  // { store: { contact: { <storeCode>: 'admin' | 'editor' | ... } } }.
  /**
   * El único condicionante es el permiso (decisión del PM, 2026-08-19: antes había además un feature
   * flag que la ocultaba por entorno, y se quitó). El backend lo exige igual sobre TODOS los stores
   * afectados, y siguen los bloqueos duros: operador/vendor, archivado, unificación en curso, y sin
   * store compartido (D6/D1b).
   */
  const hasContactAdmin = useMemo(() => {
    const storeCode = contactRecord?.storeCode;
    if (!storeCode) return false;
    const level = (identity as any)?.permissions?.store?.contact?.[storeCode];
    return level === "admin";
  }, [identity, contactRecord?.storeCode]);

  const canMergeContacts = hasContactAdmin;

  /**
   * Llegada desde el alta de contacto con `?merge=<contactId>` (OpenSpec 021).
   *
   * Pasa cuando el operador cargó un e-mail que es de un contacto y un teléfono que es de otro, los
   * dos de este store: no se puede crear, pero son dos fichas de la misma persona. El alta manda para
   * acá y el drawer se abre con el origen ya elegido.
   *
   * El origen se resuelve por su ficha porque del alta sólo viene el `contactId`: el drawer necesita
   * nombre y e-mail para el paso de confirmación.
   */
  const mergeParam = new URLSearchParams(location.search).get("merge");
  useEffect(() => {
    if (!mergeParam || !contactId) return;
    // Sin permiso (o con la ficha archivada) no se abre nada: el backend lo rechazaría igual.
    if (!canMergeContacts || contactRecord?.archived) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await axiosInstance.get(
          `${API_BASE_URL}/contacts?filter.contactId=${mergeParam}`,
        );
        const source = res?.data?.data?.[0];
        if (!source || cancelled) return;

        setMergeFromConflict({
          targetContactId: Number(contactId),
          source: {
            contactId: Number(mergeParam),
            userId: source.userId,
            name: `${source.user?.firstname ?? ""} ${
              source.user?.lastname ?? ""
            }`.trim(),
            email: source.user?.email ?? "",
            whatsapp: source.user?.whatsapp ?? null,
            isSyntheticEmail: isSyntheticEmail(source.user?.email),
            stores: source.storeCode ? [source.storeCode] : [],
            matchReason: "manual",
          },
        });
        setMergeOpen(true);
        // Se limpia el parámetro: si no, un refresh reabre el drawer.
        navigate(`/contacts/${contactId}`, { replace: true });
      } catch (error) {
        console.error("no se pudo resolver el contacto a unificar", error);
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mergeParam, canMergeContacts, contactRecord?.archived]);


  // Quotes/Orders se muestran SIEMPRE (spec 007, Fase 3 · U5 corregido con Figma
  // "CUSTOMER Contact > Contact info"): un contacto operador (Store/Seller) sin
  // pipeline de compra las ve en 0 (funnel vacío + 0 orders), no ocultas. Un
  // contacto "ambos" (operador + customer) ve su pipeline real.

  const formatLabel = (key: string) =>
    key.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

  // Fuera del alcance, o inexistente: un aviso en lugar de una ficha vacía, y sin montar el
  // historial ni nada que cuelgue del contacto (xcons-docs#549). El operador **sí** tiene permiso
  // sobre Contactos; lo que le falta es participar de esta ficha, y el texto dice eso y a quién
  // pedírselo. Va después de todos los hooks del componente.
  if (contactAccess !== "ok") {
    const forbidden = contactAccess === "forbidden";
    return (
      <Result
        status={forbidden ? "403" : "404"}
        title={
          forbidden
            ? t("contacts.detail.noAccess.title", "Este contacto no está en tu alcance")
            : t("contacts.detail.notFound.title", "Ese contacto no existe")
        }
        subTitle={
          forbidden
            ? t(
                "contacts.detail.noAccess.body",
                "No participás de esta ficha, o tu nivel de Contactos en su store no alcanza para verla. Pedile a quien administra los contactos del store que te agregue como participante.",
              )
            : t(
                "contacts.detail.notFound.body",
                "No hay ninguna ficha con ese id. Puede que la hayan unificado con otra.",
              )
        }
        extra={
          <Button type="primary" onClick={() => navigate("/contacts")}>
            {t("contacts.detail.backToList", "Volver a Contactos")}
          </Button>
        }
      />
    );
  }

  return (
    <Flex vertical>
      <Spin spinning={contactLoading}>
        <Flex align="center" gap={16} style={{ marginBottom: "40px" }}>
          <Flex gap={8} align="center">
            <ListButton onClick={handleBack} hideText icon={<LeftOutlined />} />
            <Title style={{ marginBottom: 0, marginLeft: "10px" }} level={3}>
              {`${contactRecord?.user?.firstname} ${contactRecord?.user?.lastname}`}
            </Title>
            {contactRecord?.archived && (
              <Tag style={{ marginLeft: 8, height: "fit-content" }}>
                Archived
              </Tag>
            )}
          </Flex>
          {(() => {
            // Tags de rol Operador: la fuente de verdad es
            // contactRecord.permissions = { store, seller } — membership del
            // user_id en la tabla `permissions`. El StoreFilter no afecta el
            // cómputo (el contactRecord ya es per-store).
            const { isStoreOperator, isSellerOperator } =
              getOperatorTags(contactRecord);
            if (!isStoreOperator && !isSellerOperator) return null;
            return (
              <Flex gap={6} align="center">
                {isStoreOperator && <Tag color="blue">Store Operator</Tag>}
                {isSellerOperator && <Tag color="green">Seller Operator</Tag>}
              </Flex>
            );
          })()}

          {/* Unificar contacto (OpenSpec 021). **No hay botón**: el único punto de entrada es el
              conflicto de identidad al editar la ficha (D12) — escribir el e-mail o el WhatsApp de
              otro contacto ofrece unificar. Un botón suelto pedía que el operador ya supiera que el
              duplicado existe, que es justo lo que no pasa.

              El drawer igual se monta sólo con permiso de Contactos nivel `admin` en el store y con
              el contacto sin archivar: el backend lo exige en TODOS los stores afectados, y no tiene
              sentido llegar al drawer para comerse un 403. */}
          {canMergeContacts && !contactRecord?.archived && (
            <>
              <LateralModal
                hideTrigger
                width={560}
                title={t("contacts.merge.title", "Unificar contacto")}
                openDrawer={mergeOpen}
                closeDrawer={() => {
                  setMergeOpen(false);
                  setMergeFromConflict(null);
                }}
              >
                <MergeContactDrawer
                  targetContactId={
                    mergeFromConflict?.targetContactId ?? Number(contactId)
                  }
                  initialSource={mergeFromConflict?.source ?? null}
                  triggerField={mergeFromConflict?.triggerField ?? null}
                  targetStoreCode={contactRecord?.storeCode ?? null}
                  targetName={`${contactRecord?.user?.firstname ?? ""} ${
                    contactRecord?.user?.lastname ?? ""
                  }`.trim()}
                  onDone={handleMergeDone}
                  onClose={() => {
                    setMergeOpen(false);
                    setMergeFromConflict(null);
                  }}
                />
              </LateralModal>
            </>
          )}
        </Flex>

        <Row
          gutter={12}
          wrap
          justify="center"
          style={{ width: "100%", alignItems: "stretch" }}
        >
          <Col
            xs={24}
            md={8}
            lg={8}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Card
              className="contact-card"
              styles={{
                header: {
                  height: 40,
                  minHeight: 40,
                  padding: "0 16px",
                  borderBottom: "1px solid #f0f0f0",
                },
              }}
              title={
                <Flex justify="space-between" align="center">
                  <Flex
                    gap={8}
                    align="center"
                    style={{ color: token.colorPrimary }}
                  >
                    <UserOutlined />
                    <Text
                      style={{ color: token.colorPrimary, fontWeight: 600 }}
                    >
                      {t("contacts.data")}
                    </Text>
                    <Button
                      type="text"
                      size="small"
                      icon={<EditOutlined />}
                      onClick={openContactEdit}
                      title="Editar datos del contacto"
                    />
                  </Flex>

                  <Flex
                    vertical
                    align="flex-end"
                    style={{
                      fontSize: 12,
                      color: "rgba(0,0,0,0.45)",
                      lineHeight: "16px",
                      fontWeight: "normal",
                    }}
                  >
                    <span>{t("contacts.label.createdaccount")}</span>
                    <span>
                      {dayjs(userData?.createdAt).format("DD/MM/YY, hh:mm a")}
                    </span>
                  </Flex>
                </Flex>
              }
              actions={[
                <Flex
                  key="footer"
                  justify="space-between"
                  align="center"
                  gap={8}
                  style={{ padding: "0 16px", width: "100%" }}
                >
                  <Flex align="center" gap={8}>
                    <Button
                      type="link"
                      style={{ padding: 0, color: "#2b8058", fontWeight: 600 }}
                      icon={
                        <ProfileOutlined
                          style={{ fontSize: 16, color: "#2b8058" }}
                        />
                      }
                      iconPosition="start"
                      disabled={!!contactRecord?.archived}
                      onClick={() => setAgendaOpen(true)}
                    >
                      Agenda
                    </Button>
                    <EditOutlined
                      style={{
                        fontSize: 14,
                        color: "rgba(0,0,0,0.45)",
                        cursor: "pointer",
                      }}
                      onClick={
                        !!contactRecord?.archived
                          ? undefined
                          : () => setAgendaOpen(true)
                      }
                    />
                    <LateralModal
                      hideTrigger
                      title={modalTitle}
                      openDrawer={agendaOpen}
                      closeDrawer={() => setAgendaOpen(false)}
                    >
                      <Agenda
                        userAddress={userAddress}
                        userAddressLoading={userAddressLoading}
                        updateUserAddress={getUserAddress}
                        onTitleChange={setModalTitle}
                        userId={userId ? Number(userId) : null}
                        storeCode={contactRecord?.storeCode ?? null}
                      />
                    </LateralModal>
                  </Flex>

                  <Text type="secondary" style={{ fontSize: 14 }}>
                    {userAddress?.length}
                  </Text>
                </Flex>,
              ]}
            >
              <Flex vertical gap={8} style={{ minHeight: "265px" }}>
                {/* Drawer de edición controlado por los lápices (trigger oculto) */}
                <LateralModal
                  hideTrigger
                  title={t("contacts.editData.title", "Editar datos del contacto")}
                  openDrawer={dataDrawerOpen}
                  closeDrawer={closeDataDrawer}
                  width={400}
                >
                  <Flex vertical gap={16} style={{ flex: 1, overflow: "auto" }}>
                    {(editingSection === null ||
                      editingSection === "contact") && (
                      <ContactData
                        refresh={refreshAfterSave}
                        userData={userData}
                        contactId={contactId}
                        archived={contactRecord?.archived}
                        isEditing={editingSection === "contact"}
                        onBeginEdit={() => beginEdit("contact")}
                        onEndEdit={closeDataDrawer}
                        closeModal={closeDataDrawer}
                        /* Por qué no se puede unificar, para que el aviso no mande a revisar lo
                           que no es. */
                        /* El permiso va PRIMERO: si falta, "reactivá el contacto" manda a hacer
                           algo que no va a alcanzar. */
                        mergeUnavailable={
                          !hasContactAdmin
                            ? "permission"
                            : contactRecord?.archived
                              ? "archived"
                              : "permission"
                        }
                        /* Sólo con permiso para unificar se ofrece el atajo; sin esto el conflicto
                           de identidad se informa como error del campo y nada más. */
                        onRequestMerge={
                          canMergeContacts && !contactRecord?.archived
                            ? (conflict) => {
                                if (
                                  !conflict.sourceContactId ||
                                  !conflict.targetContactId
                                )
                                  return;
                                setMergeFromConflict({
                                  // Es SIEMPRE esta ficha: el chequeo va scopeado al store de la
                                  // ficha (`contactId`), así que el par origen/destino sale de este
                                  // store. Antes el backend elegía cualquier store compartido y el
                                  // drawer podía abrir —y terminar navegando a— la ficha de otro.
                                  targetContactId: conflict.targetContactId,
                                  triggerField: conflict.field,
                                  source: {
                                    contactId: conflict.sourceContactId,
                                    userId: conflict.userId,
                                    name: conflict.name,
                                    email: conflict.email,
                                    whatsapp: conflict.whatsapp ?? null,
                                    isSyntheticEmail: conflict.isSyntheticEmail,
                                    stores: conflict.sharedStores,
                                    matchReason:
                                      conflict.field === "email" ? "email" : "phone",
                                  },
                                });
                                closeDataDrawer();
                                setMergeOpen(true);
                              }
                            : undefined
                        }
                      />
                    )}
                    {editingSection === null && <Divider />}
                    {(editingSection === null ||
                      editingSection === "aditional") && (
                      <AditionalData
                        refresh={getContactDetails}
                        userData={contactRecord}
                        isEditing={editingSection === "aditional"}
                        onBeginEdit={() => beginEdit("aditional")}
                        onEndEdit={closeDataDrawer}
                        closeModal={closeDataDrawer}
                      />
                    )}
                  </Flex>
                </LateralModal>

                {contactRecord?.storeCode && (
                  <Flex gap={8} align="center">
                    <ShopOutlined />
                    <Text strong style={{ textTransform: "capitalize" }}>
                      {contactRecord.storeCode}
                    </Text>
                  </Flex>
                )}
                <Flex align="center" gap={10}>
                  <MailOutlined />
                  {displayEmail(userData?.email) ? (
                    <ChannelPickerDropdown
                      channels={convChannels}
                      loading={convChannelsLoading}
                      failed={convChannelsFailed}
                      unavailable={convChannelsUnavailable}
                      onOpen={loadConvChannels}
                      onPick={(channelId) => {
                        const name = `${contactRecord?.user?.firstname ?? ""} ${contactRecord?.user?.lastname ?? ""}`.trim();
                        navigate(`/conversations?newMsg=msg&channelId=${encodeURIComponent(channelId)}&contactId=${contactId}&contactName=${encodeURIComponent(name)}&email=${encodeURIComponent(userData.email ?? "")}&whatsapp=${encodeURIComponent(userData.whatsapp ?? "")}&storeCode=${encodeURIComponent(contactRecord?.storeCode ?? "")}`);
                      }}
                      onAddChannel={() => navigate(`/stores/channels/${contactRecord?.storeCode}`)}
                      extraItems={[{
                        key: "__email_personal",
                        label: <Flex align="center" gap={8} style={{ padding: "4px 0", minWidth: 220 }}>{channelIcon("email")}<span>email personal</span></Flex>,
                        onClick: () => { window.location.href = `mailto:${userData.email}`; },
                      }]}
                      placement="bottomLeft"
                    >
                      <Text strong style={{ color: "#15744b", cursor: "pointer" }}>
                        {displayEmail(userData.email)}
                      </Text>
                    </ChannelPickerDropdown>
                  ) : (
                    <Text>-</Text>
                  )}
                </Flex>

                <Flex align="center" gap={10}>
                  <WhatsAppOutlined />
                  {userData?.whatsapp ? (
                    <ChannelPickerDropdown
                      channels={convChannels}
                      loading={convChannelsLoading}
                      failed={convChannelsFailed}
                      unavailable={convChannelsUnavailable}
                      onOpen={loadConvChannels}
                      onPick={(channelId) => {
                        const name = `${contactRecord?.user?.firstname ?? ""} ${contactRecord?.user?.lastname ?? ""}`.trim();
                        navigate(`/conversations?newMsg=msg&channelId=${encodeURIComponent(channelId)}&contactId=${contactId}&contactName=${encodeURIComponent(name)}&whatsapp=${encodeURIComponent(userData.whatsapp ?? "")}&email=${encodeURIComponent(userData.email ?? "")}&storeCode=${encodeURIComponent(contactRecord?.storeCode ?? "")}`);
                      }}
                      onAddChannel={() => navigate(`/stores/channels/${contactRecord?.storeCode}`)}
                      extraItems={[{
                        key: "__wa_personal",
                        label: <Flex align="center" gap={8} style={{ padding: "4px 0", minWidth: 220 }}><WhatsAppOutlined style={{ fontSize: 16 }} /><span>WhatsApp Web personal</span></Flex>,
                        onClick: () => { window.open(`https://wa.me/${(userData.whatsapp ?? "").replace(/[^\d]/g, "")}`, "_blank"); },
                      }]}
                      placement="bottomLeft"
                    >
                      <Text strong style={{ color: "#15744b", cursor: "pointer" }}>
                        {userData.whatsapp}
                      </Text>
                    </ChannelPickerDropdown>
                  ) : (
                    <Text>-</Text>
                  )}
                </Flex>

                <Flex align="center" gap={10}>
                  <FlagOutlined />
                  <Text>{userData?.company ?? "-"}</Text>
                </Flex>

                <Divider style={{ margin: "12px 0 9px 0" }} />

                <Flex
                  vertical
                  gap={8}
                  style={{ overflowY: "auto", maxHeight: "265px" }}
                >
                  <Flex
                    align="center"
                    gap={8}
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "white",
                    }}
                  >
                    <Text strong>{t("contacts.label.additionaldata")}</Text>
                    <Button
                      type="text"
                      size="small"
                      icon={<EditOutlined />}
                      onClick={openAditionalEdit}
                      disabled={!!contactRecord?.archived}
                      title={t("contacts.label.additionaldata")}
                    />
                  </Flex>

                  <Flex vertical>
                    {additionalEntries.length > 0 ? (
                      <ul style={{ paddingLeft: 18, margin: 0 }}>
                        {additionalEntries.map(([key, value]) => (
                          <li key={key}>
                            <Text>
                              <strong>{formatLabel(key)}:</strong>{" "}
                              {String(value)}
                            </Text>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <Text type="secondary">
                        {t("contacts.label.noadditionaldata")}
                      </Text>
                    )}
                  </Flex>
                </Flex>
              </Flex>
            </Card>

            {/* <Collapse
              style={{
                marginTop: 16,
              }}
              items={collapseConversations}
              defaultActiveKey={["conversations"]}
            /> */}
          </Col>

          <Col xs={24} md={8} lg={8}>
            <Collapse
              className="contact-card-height"
              items={collapseQuotes}
              defaultActiveKey={["quotes"]}
            />
          </Col>

          <Col xs={24} md={8} lg={8}>
            <Collapse
              className="contact-card-height"
              items={collapseOrders}
              defaultActiveKey={["orders"]}
            />
          </Col>
        </Row>

        <Row
          gutter={12}
          wrap
          justify="center"
          style={{ width: "100%", marginTop: 32 }}
        >
          <Col xs={24} md={16} lg={16}>
            <Card
              className="history-card"
              styles={{
                header: { height: 40, minHeight: 40, padding: "0 16px" },
                body: {
                  padding: 0,
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                },
              }}
              title={
                <Flex align="center" gap={24} style={{ width: "100%" }}>
                  <Flex gap={4} align="center" style={{ flexShrink: 0 }}>
                    <HistoryOutlined style={{ fontSize: 16 }} />
                    <Text style={{ fontSize: 14, fontWeight: 600 }}>
                      {t("products.show.tableHistory")}
                    </Text>
                  </Flex>
                  <Flex flex={1} gap={16} align="center">
                    <Input.Search
                      size="small"
                      allowClear
                      placeholder="Search..."
                      value={historySearch}
                      onChange={(e) => setHistorySearch(e.target.value)}
                      style={{ flex: 1 }}
                    />
                    <Button
                      size="small"
                      shape="round"
                      icon={<FilterOutlined style={{ fontSize: 14 }} />}
                    />
                  </Flex>
                </Flex>
              }
            >
              {/* Historial transversal del contacto (OpenSpec 008) — buscador en el header del Card */}
              {contactId ? (
                <HistorySection
                  // El historial fetchea por su cuenta: sin remontarlo, después de unificar no
                  // aparecen ni el evento `merged` ni los eventos que se trasladaron del absorbido.
                  key={`history-${contactId}-${refreshKey}`}
                  module="contact"
                  entityId={Number(contactId)}
                  externalQ={historyQ}
                  scrollable
                />
              ) : null}
            </Card>
          </Col>

          <Col xs={24} md={8} lg={8}>
            <Collapse
              className="contact-card-height contact-card-hug"
              items={collapseGroups}
              defaultActiveKey={["groups"]}
            />

            <Collapse
              className="contact-card-height contact-card-hug"
              style={{ marginTop: 16 }}
              items={collapseRelations}
              defaultActiveKey={["relations"]}
            />
          </Col>
        </Row>
      </Spin>
    </Flex>
  );
};
